import { connect } from 'react-redux';
import SyncApp from './SyncApp';
import { getAuthInfo, syncTokenWithStore } from '../../reducers/auth.actions';
import { getDropdownsChoices } from '../../reducers/config.actions';

function mapStateToProps(state, otherProps) {
  return {
    token: state.auth.sessionToken,
    fetchStatus: state.auth.loginFetchStatus,
  };
}

export default connect(mapStateToProps, { syncTokenWithStore, getAuthInfo, getDropdownsChoices })(
  SyncApp
);
